/* @HEADER
 * @version 1.1.1434 | 2026-11-01
 * @purpose Where the project settings panel stands (ZVX-DEV-8842): the place beside the gear that opened it, moved so that the whole box is inside the window, 8 px from every edge at most.
 * @sidecar projectSettingsPanelPlace.ts.header.md
 * @layer app | @hex _none_ | @ctx kanban
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-8842

const MARGIN = 8

/** Pure: no DOM. The box is moved left and up as far as it must be to fit, never past the margin at the left or the top. */
export function clampPanelPlace(
  place: { top: number; left: number },
  size: { width: number; height: number },
  window: { width: number; height: number },
): { top: number; left: number } {
  const left = Math.max(MARGIN, Math.min(place.left, window.width - size.width - MARGIN))
  const top = Math.max(MARGIN, Math.min(place.top, window.height - size.height - MARGIN))
  return { top, left }
}
